<template>
    <v-container>
        <div v-if="isAdminUser">
            <v-form ref="form" v-model="valid" lazy-validation >
            <div>
                  <v-alert dismissible :value="successVisible" type="success" transition="slide-y-transition">{{this.alertMessage}}</v-alert>
                  <v-alert dismissible :value="errorVisible" type="error" transition="slide-y-transition">{{this.alertMessage}}</v-alert>
            </div>
            <v-card-title>
                New Radiation - Source
            </v-card-title>
            <v-card elevation="2" outlined shaped >
                <v-card-text>
                    <v-row>
                        
                        <v-col cols="3">
                            <v-combobox dense v-model="radiation.building" :items="buildings" :return-object="true" label="Building"  
                                @change="onBuildingChange" :rules="[v=>!!v || 'Building is required']" required>
                                <template #label > <span class="bolder--text">Building</span> <span class="red--text"> <strong>*</strong></span></template>
                            </v-combobox>
                            <v-spacer></v-spacer>
                            <v-dialog v-model="isBuildingDialogVisible" persistent max-width="290">
                                <v-card>
                                    <v-card-title class="text-h5">
                                        Add new Building
                                    </v-card-title>
                                    <v-card-text>
                                        Do you want to add a new Building?
                                    </v-card-text>
                                    <v-card-text>
                                        <v-form ref="formNewBuilding" v-model="validNewBuilding" lazy-validation>
                                            <v-text-field dense label="Code" v-model="newBuilding.code" prepend-icon="edit" :rules="[v=>!!v || 'Buiding Code is required']" required></v-text-field>
                                            <v-text-field dense label="Description" v-model="newBuilding.description" prepend-icon="edit" :rules="[v=>!!v || 'Buiding Description is required']" required></v-text-field>
                                        
                                            <v-card-actions>
                                                <v-spacer></v-spacer>
                                                <v-btn color="green darken-1" text @click="isBuildingDialogVisible=false">Cancel</v-btn>
                                                <v-btn color="green darken-1" text @click="onSavingNewBuilding">Save</v-btn>
                                            </v-card-actions>
                                    </v-form>
                                    </v-card-text>
                                </v-card>
                            </v-dialog>
                        </v-col>
                        <v-col cols="3">
                            <v-combobox dense v-model="radiation.floor" :items="floors" @change="onFloorChange" label="Floor" :return-object="true" :rules="[v=>!!v || 'Floor is required']" required>
                                <template #label>Floor <span class="red--text"> <strong>*</strong></span></template>
                            </v-combobox>
                            <v-spacer></v-spacer>
                            <v-dialog v-model="isFloorDialogVisible" persistent max-width="290">
                                <v-card>
                                    <v-card-title class="text-h5">Add new floor</v-card-title>
                                    <v-card-text>
                                        Do you want to a new floor?
                                    </v-card-text>
                                    <v-card-text>
                                        <v-form ref="formNewFloor" v-model="validNewFloor" lazy-validation>
                                        <v-text-field dense label="Floor" v-model="newFloor.code" prepend-icon="edit" :rules="[v=>!!v || 'Code floor is required']" required></v-text-field>
                                        
                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn color="green darken-1" text @click="isFloorDialogVisible=false">Cancel</v-btn>
                                            <v-btn color="green darken-1" text @click="onSavingNewFloor">Save</v-btn>
                                        </v-card-actions>
                                    </v-form>
                                    </v-card-text>
                                    
                                </v-card>
                            </v-dialog>
                        </v-col>
                        <v-col cols="3">
                            <v-text-field dense label="Location Description" v-model="radiation.location">
                                <template #label>Location Description<span class="red--text"> <strong>*</strong></span></template>
                            </v-text-field>
                        </v-col>
                        <v-col cols="2">
                             <!--<v-checkbox dense label="Shutter" v-model="radiation.shutt"></v-checkbox>-->
                              <v-combobox dense v-model="radiation.shutt" label="Has a Shutter" :items="hasShutterOptions" :return-object="true" @change="onShutterChange" :rules="[v=>!!v || 'Has a Shutter is required']" required>
                              </v-combobox>
                        </v-col>
                    </v-row>
                    <v-row>
                        
                        <v-col cols="3">
                            <v-text-field dense label="Serial Number" v-model="radiation.serialNumber" :rules="[v=>!!v || 'Serial Number is required']" required>
                                <template #label>Serial Number <span class="red--text"><strong>*</strong></span></template>
                            </v-text-field>
                        </v-col>
                    
                        <v-col cols="3">
                            <v-combobox dense v-model="radiation.isotope" :items="isotopes" label="Isotope" @change="onIsotopeChange" :return-object="true" :rules="[v=>!!v || 'Isotope is required']" required>
                                <template #label>Isotope <span class="red--text"> <strong>*</strong></span></template>
                            </v-combobox>
                            <v-spacer></v-spacer>
                            <v-dialog v-model="isIsotopeDialogVisible" persistent max-width="290">
                                <v-card>
                                    <v-card-title class="text-h5">Add new Isotope</v-card-title>
                                    <v-card-text>Do you want to add a new Isotope?</v-card-text>
                                    <v-card-text>
                                        <v-form ref="formNewIsotope" lazy-validation>
                                            <v-text-field dense label="Isotope" v-model="newIsotope.code" :rules="[v=>!!v || 'Isotope is required']" required prepend-icon="edit"></v-text-field>

                                            <v-card-actions>
                                                <v-btn color="green darken-1" text @click="isIsotopeDialogVisible=false" >Cancel</v-btn>
                                                <v-btn color="green darken-1" text @click="onSavingNewIsotope">Save</v-btn>
                                            </v-card-actions>
                                        </v-form>
                                    </v-card-text>
                                    
                                </v-card>
                            </v-dialog>
                        </v-col>
                        <v-col cols="3">
                            <template>
                            <div>
                                <v-tooltip name="tooltipMCI" top color="warning">
                                    <template v-slot:activator="{on, attrs}">
                                        <v-text-field dense label="MCI" v-model="radiation.mci"   :rules="[v=>!!v || 'MCI is required']" v-bind="attrs" v-on="on" required>
                                            <template #label> <span>MCI <strong class="red--text">*</strong> </span>  </template>
                                        </v-text-field>
                                    </template>
                                    <span>
                                        MCI meaning to be defined
                                    </span>
                                </v-tooltip>
                            </div>
                            </template>
                        </v-col>
                    </v-row>
                <br/>
                    <v-row>
                            <v-col cols="3">
                                <div>
                                    <v-tooltip top color="warning">
                                        <template v-slot:activator="{on,attrs}">
                                            <div v-bind="attrs" v-on="on">
                                                <v-select dense v-model="radiation.leak" label="Leak" :items="leaks" :return-object="true" :rules="[v=>!!v || 'Leak is required']" required >
                                                    <template #label>Leak Test Interval<span class="red--text"> <strong>*</strong></span></template>
                                                </v-select>
                                            </div>
                                            
                                        </template>
                                        <span>Leak Test Interval</span>
                                    </v-tooltip>
                                </div>
                            </v-col>    
                            <v-col cols="3">
                                <!--<v-text-field dense label="Leak Test Reference Number" v-model="radiation.testReferenceNumber" :rules="[v=>!!v || 'Test Reference Number is required']" required>
                                    <template> Leak Test Reference Number <span> <strong class="red--text">*</strong> </span></template>
                                </v-text-field>
                                <v-select dense v-model="radiation.leakTestGroup" label="Leak Test Group" :items="leakTestGroups" :rules="[v=>!!v || 'Leak Test Group is required']" required>
                                <template #label> Leak Test Group <span> <strong class="red--text">*</strong></span></template>
                                </v-select>-->
                                <v-combobox dense v-model="radiation.leakTestGroup" :items="leakTestGroups" :return-object="true" :rules="[v=>!!v || 'Leak Test Group is required']" required>
                                    <template #label>Leak Test Group <span class="red--text"><strong>*</strong></span></template>
                                </v-combobox>
                            </v-col>
                            
                            <v-col cols="3">
                               
                               <v-combobox dense v-model="radiation.holder" label="Holder" :items="holders" :return-object="true" 
                                   @change="onHolderChange" :rules="[v=>!!v || 'Holder']" required>
                                                   <template #label>Holder <span class="red--text"> <strong>*</strong></span></template>
                               </v-combobox>
                               <HolderPanel :isVisible="showHolderDialog" :newHolder="newHolder" @close:isVisible="onCloseHolderPanel" @add:newHolder="onSaveHolderPanel"></HolderPanel>
                           </v-col>
                           <v-col cols="3">
                               <v-text-field dense label="Holder Serial Number" v-model="radiation.holderSerialNumber">
                                   <template #label> Holder Serial Number</template>
                               </v-text-field>
                           </v-col>
                        </v-row>
                        
                        <v-row>     
                            <v-col cols="3">
                                <v-text-field dense label="P&ID Tag" v-model="radiation.tag">
                                    <template #label>P&ID Tag</template>
                                </v-text-field>
                            </v-col>      
                            <v-col cols="3">
                                    <div>
                                        <v-tooltip top color="warning">
                                            <template v-slot:activator="{on,attrs}">
                                                <v-text-field dense label="PO" v-model="radiation.po" :rules="[v=>!!v || 'PO is required']" v-bind="attrs" v-on="on" required>
                                                    <template #label>PO <span class="red--text"> <strong>*</strong></span></template>
                                                </v-text-field>
                                            </template>
                                            <span>PO meaning to be defined</span>
                                        </v-tooltip>
                                    </div>
                                    
                            </v-col>
                            
                            <v-col cols="3">
                                    <div>
                                        <v-tooltip top color="warning">
                                            <template v-slot:activator={on,attrs}>
                                                <v-text-field dense label="MFG" v-model="radiation.mfg" :rules="[v=>!!v || 'MFG is required']" v-bind="attrs" v-on="on" required>
                                                    <template #label>MFG <span class="red--text"> <strong>*</strong></span></template>
                                                </v-text-field>
                                            </template>
                                            <span>MFG</span>
                                        </v-tooltip>
                                    </div>
                            </v-col>
                            <v-col cols="3">        
                                <v-text-field dense label="Use Building" v-model="radiation.useBuilding" >
                                    
                                </v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="3">
                                <v-combobox dense label="install Status" v-model="radiation.installed" :items="installedOptions" :return-object="true" :rules="[v=>!!v || 'install Status required']" required>
                                    <template #label>Install Status<span class="red--text"><strong>*</strong></span></template>
                                </v-combobox>
                            </v-col>
                            
                            <v-col cols="3">
                                <v-combobox dense :items="secureLoadOptions" label="Secure By Lock and Cable" v-model="radiation.secureByLock" 
                                    :return-object="true" @change="onSecureByLockAndCableChange" :rules="[v=>!!v || 'Comment']" required >
                                        <template #label>Secure By Lock and Cable <span class="red--text"> <strong>*</strong></span></template>
                                </v-combobox>
                            </v-col>  
                            <v-col cols="3">
                                <v-text-field dense label="Reason Not Secure" v-model="radiation.reasonNotSecure"></v-text-field>
                            </v-col>
                            <v-col cols="3">
                                    <v-menu 
                                        ref="menu" 
                                        v-model="menu" 
                                        :close-on-content-click="false"
                                        transition="scale-transition"
                                        offset-y 
                                        max-width="290px"
                                        min-width="auto">
                                        <template v-slot:activator="{ on , attrs}">
                                            <v-text-field 
                                                dense
                                                v-model="radiation.receiveDate"
                                                label="Receive Date"  
                                                hint="MM/DD/YYYY Format"
                                                persistent-hint
                                                prepend-icon="mdi-calendar"
                                                v-bind="attrs"
                                                @blur="dateReceive=parseDate(radiation.receiveDate)"
                                                v-on="on" :rules="[v=>!!v || 'Receive Date is required']" required>
                                                <template #label>Received Date <span class="red--text"> <strong>*</strong></span></template>
                                            </v-text-field>
                                        </template>
                                        <v-date-picker v-model="dateReceive" no-title @input="menu=false">
                                    </v-date-picker>
                                </v-menu>
                            </v-col>    
                        </v-row>
                        <!--<v-row>
                            <v-col cols="4">
                                
                                    <v-menu 
                                    ref="menu2" 
                                    v-model="menu2" 
                                    :close-on-content-click="false"
                                    transition="scale-transition"
                                    offset-y 
                                    max-width="290px"
                                    min-width="auto" >
                                    <template v-slot:activator="{ on ,attrs}">
                                        <v-text-field
                                            dense 
                                            v-model="radiation.update"
                                            label="Update"  
                                            hint="MM/DD/YYYY Format"
                                            persistent-hint
                                            prepend-icon="mdi-calendar"
                                            v-bind="attrs"
                                            @blur="dateUpdate=parseDate(radiation.update)"
                                            v-on="on" 
                                            :rules="[v=>!!v || 'Update is required']" required>
                                                <template #label>Update <span class="red--text"> <strong>*</strong></span></template>
                                            </v-text-field>
                                    </template>
                                    <v-date-picker v-model="dateUpdate" no-title @input="menu2=false" >
                                    </v-date-picker>
                                </v-menu>
                            
                                
                            </v-col>
                        </v-row>
                            -->
                        <v-row>
                            <v-col cols="6">
                                <v-select  multiple dense v-model="radiation.users" :items="userList" :return-object="true" :readonly=true>
                                        <template #label>Area Management Contact </template>
                                </v-select>
                            </v-col>
                            <v-col cols="6">
                                <v-select  
                                        v-model="radiation.mailing"
                                        :items="userList"
                                        dense
                                        multiple 
                                        :return-object="true"
                                        :readonly=true>
                                        <template #label>Primary Contact </template>
                                </v-select>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="6">
                                <v-text-field dense v-model="radiation.comment" label="Comments"></v-text-field>
                            </v-col>
                        </v-row>
                        <br/>
                        <ConfirmationPanel :isVisible="isConfirmVisible" :message="confirmMessage" @confirm:click="confirmSaving"></ConfirmationPanel>
                        <div class="text-right">
                            <v-btn color="error" dark to="/radiation/radiationlist" style="margin-right:15px;">Cancel</v-btn>
                            <v-btn dark color="success" @click="onSavingRadiation" style="margin-left:15px;">Save Device</v-btn>
                        </div>
                </v-card-text>
            </v-card>
        </v-form>
        </div>
        <div v-else>
            <h3>Access Denied</h3>
        </div>

        
</v-container>
</template>

<script>
import {validationMixin} from 'vuelidate';
import {required, maxLength} from 'vuelidate/lib/validators';
import radiationAPI from '@/services/radiationservice';
import userAPI from '@/services/userservice';
import moment from 'moment';
import HolderPanel from '@/views/radiation/HolderPanel';

class DropBoxAdapater{
    constructor(initializer){
        this.text=initializer.description;
        this.value=initializer.code;
        this.disabled=false;
        this.divider=false;
    }
}

class DropBoxAdapaterValueandText{
    constructor(initializer){
        this.text=initializer.code +' - '+initializer.description;
        this.value=initializer.code;
        this.disabled=false;
        this.divider=false;
    }
}

class DropBoxUser{
    constructor(initializer)
    {
        this.text=initializer.name;
        this.value=initializer.userId;
        this.disabled=false;
        this.divider=false;
    }
}

export default {
    name: "NewRadiation",
    data: function(){
        return {
            buildings:[],
            floors:[],
            shutts:[{value:'yes',text:'Yes'},
                {value:'no', text:'No'}
            ],
            leaks:[{value:'3YR',text:'3YR'},{value:'6MO',text:'6MO'}],
            leakTestGroups:[],
            userList:[],
            userMailings:[],
            isotopes:[],
            holders:[],
            installedOptions:[],
            hasShutterOptions:[
                { value:'false', text:'No'},
                { value: 'true', text:'Yes'}
            ],
            valid:false,
            validNewBuilding:false,
            validNewFloor:false,
            isBuildingDialogVisible:false,
            isFloorDialogVisible:false,
            isIsotopeDialogVisible:false,
            isConfirmVisible:false,
            confirmMessage:'',
            showHolderDialog: false,
            radiation:{
                building:null,
                floor:null,
                location:null,
                shutt:{ value:'false', text:'No'},
                serialNumber:'',
                isotope:null,
                mci:'',
                users:[],
                mailing:[],
                leak:null,
                //testReferenceNumber:'',
                leakTestGroup:'',
                holder:null,
                holderSerialNumber:'',
                tag:'',
                receiveDate: this.formatDate((new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)),
                po:'',
                source:'',
                mfg:'',
                useBuilding:'',
                update: this.formatDate((new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)),
                installed:null,
                secureByLock:'',
                reasonNotSecure: '',
                comment: ''
            },
            newBuilding:{
             code:'',
             description:''
            },
            newFloor:{
                code: '',
                description: ''
            },
            newIsotope:{
                code:'',
                description:''
            },
            newHolder:{
                code:'',
                description:''
            },
            dateReceive:(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            dateUpdate:(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            dateUserChange:(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            dateMailingChange:moment(Date.now()).format('YYYY-MM-DD'),
            menu: false,
            menu2: false,
            menuUserChange:false,
            menuMailingChangeDate:false,
            alertMessage: '',
            successVisible: false,
            errorVisible:false
            
        }
    },
    mixins: [validationMixin],
    validations:{
        newRadiation:{
            building:{
                required,
                maxLength: maxLength(50)
            }
        }
    },
    watch:{
        dateReceive(val)
        {
            this.radiation.receiveDate=this.formatDate(val);
        },
        dateUpdate(val){
            this.radiation.update=this.formatDate(val);
        },
        dateUserChange(val){
            this.radiation.userChangeDate=this.formatDate(val)
        },
        dateMailingChange(val){
            this.radiation.mailingChangeDate=this.formatDate(val);
        }

    },
    methods:{  
        validate:  function() {
         return  this.$refs.form.validate();
        },
        onSavingRadiation: async function(){
            this.valid=this.validate();
            if(this.valid){
            this.confirmMessage="Save Radiation Source";
            this.isConfirmVisible=true;
            }
        },
        confirmSaving: async function(value){
            
                this.isConfirmVisible=false;
                if(value)
                    this.onSaveRadiation();
            
        },
        onSaveRadiation: async function()
        {
            this.valid=this.validate();
            if(this.valid){
                const users=[];
                this.radiation.users.map((value)=>{
                    console.log('value users',value)
                    users.push(value.value)
                    
                });

                const mailings=[];
                this.radiation.mailing.map((value)=>{
                    console.log('value mailing',value)
                    mailings.push(value.value)
                    
                });

                const model={
                   radiationId:0,
                   building:this.radiation.building.value,
                   floor:this.radiation.floor.value,
                   location:this.radiation.location,
                   shutt:this.stringToBoolean(this.radiation.shutt.value),
                   serialNumber: this.radiation.serialNumber,
                   isotope:this.radiation.isotope.value,
                   mci:this.radiation.mci,
                   leak:this.radiation.leak.value,
                   leakTestGroup: this.radiation.leakTestGroup.value,
                   holder: this.radiation.holder.value,
                   holderSerialNumber:this.radiation.holderSerialNumber,
                   tag: this.radiation.tag,
                   po: this.radiation.po,
                   source:this.radiation.source,
                   mfg:this.radiation.mfg,
                   useBuilding:this.radiation.useBuilding,
                   install: this.radiation.installed.value,
                   secureByLock: this.radiation.secureByLock,
                   reasonNotSecure: this.radiation.reasonNotSecure,
                   receiveDate: this.parseDate(this.radiation.receiveDate),
                   update: this.parseDate(this.radiation.update),
                   users: users,
                   mailing: mailings,
                   comment: this.radiation.comment
                   //dispDate: this.formatDate((new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)),
                   //dispSite: '',
                   //dispMSO:''
                };

                console.log("Saving valid",model);

                await radiationAPI.addRadiation(model)
                    .then(response=>{
                        if(response.status===200 || response.status===201){
                            this.alertMessage='Radiation input was created';
                            this.successVisible=true;
                            this.hideAlert();
                            this.newRadiation=response.data.radiationId;
                            this.$router.push(`/radiation/updateradiation/${this.newRadiation}`)

                        }else{
                            this.alertMessage='Radiation creation failed';
                            this.errorVisible=true;
                        }
                    })
                    .catch(error=>{console.log(error)});
            }
        },
        hideAlert: function(){
             window.setInterval(()=>{
                this.successVisible=false;
                this.errorVisible=false;
            },10000);
        },
        formatDate (date) {
        if (!date) return null;

        const [year, month, day] = date.split('-')
        return `${month}/${day}/${year}`
        },
        parseDate (date) {
           
            if (!date) return null;

            const [month, day, year] = date.split('/')
            return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
        },
        stringToBoolean: function(string){
            switch(string.toLowerCase().trim()){
                    case "true": case "yes": case "1": return true;
                    case "false": case "no": case "0": case null: return false;
                default: return Boolean(string);
                }
        },
        async loadBuildings()
        {
            radiationAPI.getAllBuildings()
            .then(response=>{
                this.buildings=response.data.map(building=>new DropBoxAdapaterValueandText(building));
            })
            .catch(error=>{console.log(error)});
        },
        async onBuildingChange(entry) {
            
            if(typeof(entry)==='string' && entry.trim()){
                var splited=[];
                var value='';
                if(entry.includes('-'))
                {
                    splited=entry.split('-');
                    value=splited[0].trim();
                    this.newBuilding={ code:splited[0].trim(), description:splited[1].trim()}
                }
                else
                {
                    value=entry;
                    this.newBuilding={ code:entry.trim()}
                }
                const item=this.buildings.find(building=>building.value===value);
                console.log('item finded', item);
                if(item){
                    this.radiation.building={value:item.value, text: item.value+' - '+ item.text };
                } else{
                        this.isBuildingDialogVisible=true;   
                }
            }
            else
            {
                console.log('Building',entry); 
                await userAPI.getUsersByBuilding(entry.value)
                    .then(response=>{
                        if(response.data!=null){
                            console.log(response.data);
                            this.radiation.users=response.data;
                        }
                        else{
                            this.radiation.users=null;
                        }
                    })
                    .catch(error=>{console.log(error)}); 
                
                await userAPI.getPrimaryContactByBuilding(entry.value)
                    .then(response=>{
                        console.log("response email", response);
                        if(response!=null){
                            this.radiation.mailing=response;
                        }else{
                            this.radiation.mailing=null;
                        }
                    })
                    .catch(error=>{console.log(error)});
                

            }
        },
        async addNewBuilding(entry)
        {
            await radiationAPI.addBuilding(entry);
            return entry;
        },
        async onSavingNewBuilding(){
            
            if(this.$refs.formNewBuilding.validate())
            {
                
                const selected= await this.addNewBuilding(this.newBuilding);
                console.log(selected.code, selected.description);
                await this.loadBuildings();
                this.radiation.building={value: selected.code, text: selected.code+' - '+ selected.description };
                console.log("Saving new building");
                this.isBuildingDialogVisible=false;
            }
            else{
                console.log("Validation error");
            }
        },
        async loadFloors()
        {
             radiationAPI.getFloors()
                .then(response=>{
                    this.floors=response.data.map(floor=>new DropBoxAdapater(floor));
                })
                .catch(error=>{console.log(error)});
        },
        async onFloorChange(entry){
            if(typeof(entry)==='string' && entry.trim()){
                const item=this.floors.find(floor=>floor.value===entry);
                if(item){
                    this.radiation.floor={value: item.value, text: item.value+ ' - '+item.text};
                } else {
                    this.newFloor.code=entry;
                    this.isFloorDialogVisible=true;
                }
            }
        },
        async onSavingNewFloor()
        {
            if(this.$refs.formNewFloor.validate()){
                var selected=null;
                this.newFloor.description=this.newFloor.code;
                await radiationAPI.addFloor(this.newFloor).
                    then(response=>{
                        selected={value: response.code, text: response.description};
                    })
                    .catch(error=>{console.log(error)});
                await this.loadFloors();
                this.radiation.floor=selected;
                this.isFloorDialogVisible=false;
            } else{
                console.log('Validation Error');
            }
        },
        onShutterChange: async function(dropBox){
            console.log(typeof(dropBox));
            if(typeof(dropBox)==='object')
            {
                this.radiation.shutt=dropBox;
            }
            else{
                this.radiation.shutt={ value:'false',text:'No'};
            }
        },
        async loadIsotopes(){
            radiationAPI.getIsotopes()
            .then(response=>{
                this.isotopes=response.data.map(isotope=>new DropBoxAdapater(isotope));
            })
            .catch(error=>{console.log(error)});

        },
        async onIsotopeChange(entry){
           if(typeof(entry)==='string' && entry.trim()){
                const item=this.isotopes.find(isotope=>isotope.value===entry);
                if(item){
                    this.radiation.isotope={value: item.value, text: item.value+ ' - '+item.text};
                } else {
                    this.newIsotope.code=entry;
                    this.isIsotopeDialogVisible=true;
                }
            }
        },
        async onSavingNewIsotope(){
            if(this.$refs.formNewIsotope.validate()){
                var selected=null;
                this.newIsotope.description=this.newIsotope.code;
                await radiationAPI.addIsotope(this.newIsotope).
                    then(response=>{
                        selected={value: response.code, text: response.description};
                    })
                    .catch(error=>{console.log(error)});
                await this.loadIsotopes();
                this.radiation.isotope=selected;
                this.isIsotopeDialogVisible=false;
            } else{
                console.log('Validation Error');
            }
        },
        async onHolderChange(dropBox){
            if(typeof(dropBox)==='string' && dropBox.trim()){
                const item=this.holders.find(holder=>holder.value===dropBox);
                if(item){
                    this.radiation.holder={value: item.value, text: item.text};
                } else {
                    this.newHolder={code: dropBox, description: dropBox};
                    this.showHolderDialog=true;
                }
            }
        },
        onCloseHolderPanel: function(value){
            this.showHolderDialog=value;
        },
        onSaveHolderPanel: function(value){
            this.loadHolders();
            this.radiation.holder={value: value.code, text: value.description };
            this.showHolderDialog=false;
        },
        loadHolders: async function(){
            await radiationAPI.getHolders()
            .then(response=>{
                this.holders=response.data.map(holder=>new DropBoxAdapater(holder));
            })
            .catch(error=>{console.log(error)});
        },
        async onSecureByLockAndCableChange(dropBox)
        {
            if(typeof(dropBox)==='object' && dropBox!==null){
                this.radiation.secureByLock=dropBox.text;
            } else if(typeof(dropBox)==='string' && dropBox.trim()){
                this.radiation.secureByLock=dropBox;
            }
        },
    },
    computed:{
        secureLoadOptions(){
            return[
                {text:"Yes"},
                {text: "No"}
            ];
        },
        isAdminUser()
        {
            let foundIndex=this.$msal.data.user.idToken.roles.indexOf('radiation-admin-role');   
            if(foundIndex!=-1)
            {
                return true;
            }
            else
            {
                return false;
                
            }
        }

    },
    mounted: async function(){
        console.log('mounting');
        await this.loadBuildings();

        await this.loadFloors();
        this.loadIsotopes();

        radiationAPI.getLeakTestGroups()
        .then(response=>{
            this.leakTestGroups=response.data.map(leakTestGroup=>new DropBoxAdapater(leakTestGroup))
        })
        .catch(error=>{console.log(error)});

        
        radiationAPI.getHolders()
        .then(response=>{
            this.holders=response.data.map(holder=>new DropBoxAdapater(holder));
        })
        .catch(error=>{console.log(error)});

        await radiationAPI.getInstallOptions()
        .then(response=>{
            console.log('Install Options',response);
            this.installedOptions=response.map(installOption=>new DropBoxAdapater(installOption));
        })
        .catch(error=>{console.log(error)});

        userAPI.getUsers()
        .then(response=>{
            this.userList=response.data.map(user=>new DropBoxUser(user))})
        .catch(error=>{console.log(error)});

       
        
    },
    components:{
        HolderPanel,
        ConfirmationPanel: ()=> import('@/views/commond/ConfirmationPanel')
    }
   
}
</script>

<style scoped>
    .required label::after {
    content: "*";
}
</style>